<template>
  <div>
    <loading :active.sync="isLoading" />

    <div class="app-title">
      <div>
        <h1><i class="fas fa-users"></i> ผู้ใช้งาน</h1>
        <p>[{{ name }}]</p>
      </div>
    </div>

    <div class="tile">
      <div class="tile-title-w-btn">
        <h3 class="title">ผู้ใช้งานทั้งหมด</h3>

        <button @click="openModal" class="btn btn-primary">
          <i class="fas fa-plus"></i> เพิ่มผู้ใช้งาน
        </button>
      </div>

      <table class="table table-bordered" v-if="users.length">
        <thead class="bg-light">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Roles</th>
            <th>Position</th>
            <th width="120">Manage</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, i) in users" :key="item.id">
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>

            <td>
              <span v-for="r in item.roles" :key="r.id">
                {{ r.role_name }}
              </span>
            </td>

            <td>{{ item.position }}</td>

            <td>
              <div class="btn-group btn-group-sm">
                <button class="btn btn-warning" @click="edit(item)">
                  <i class="fas fa-edit" />
                </button>

                <button
                  class="btn btn-danger"
                  :disabled="item.id === user.id"
                  @click="del(item.id)"
                >
                  <i class="fas fa-trash" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->

    <div class="modal fade" ref="modalRef">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5>ฟอร์มข้อมูลผู้ใช้งาน</h5>
            <button class="close" @click="modal.hide()">&times;</button>
          </div>

          <form
            ref="form"
            class="needs-validation"
            novalidate
            @submit.prevent="submit"
          >
            <div class="modal-body">

              <div class="form-group">
                <label>ชื่อ-นามสกุล</label>
                <input v-model="data.name" class="form-control" required />
              </div>

              <div class="form-group">
                <label>Email</label>
                <input v-model="data.email" class="form-control" required />
              </div>

              <div class="form-group">
                <label>ตำแหน่ง</label>
                <input v-model="data.position" class="form-control" required />
              </div>

              <!-- Password -->

              <div class="form-group">
                <label>Password</label>
                <input
                  v-model="data.password"
                  type="password"
                  class="form-control"
                  :required="!isEdit"
                />
              </div>

              <div class="form-group">
                <label>Confirm Password</label>
                <input
                  v-model="data.password_confirmation"
                  type="password"
                  class="form-control"
                  :required="!isEdit"
                />
              </div>

              <div class="form-group">
                <label>Roles</label>

                <select v-model="data.roles" class="custom-select" multiple>
                  <option v-for="r in roles" :key="r.id" :value="r">
                    {{ r.role_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-primary" v-if="!isEdit">
                <i class="fas fa-save" /> บันทึก
              </button>

              <button class="btn btn-warning" v-else>
                <i class="fas fa-edit" /> แก้ไข
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click="modal.hide()"
              >
                ปิด
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import UsersService from "../services/users.service";
import RolesService from "../services/roles.service";

export default {
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },

  data() {
    return {
      modal: null,
      users: [],
      roles: [],
      isEdit: false,
      isLoading: false,
      name: this.$route.name,

      data: this.emptyForm(),
    };
  },

  methods: {
    emptyForm() {
      return {
        id: null,
        name: "",
        email: "",
        position: "",
        password: "",
        password_confirmation: "",
        roles: [],
      };
    },

    openModal() {
      this.data = this.emptyForm();
      this.isEdit = false;
      this.modal.show();
    },

    edit(user) {
      this.data = { ...user, password: "", password_confirmation: "" };
      this.isEdit = true;
      this.modal.show();
    },

    async submit() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        return;
      }

      if (!this.isEdit && this.data.password !== this.data.password_confirmation) {
        alert("Password not match");
        return;
      }

      this.isEdit ? await this.update() : await this.insert();

      this.modal.hide();
      this.getUsers();
    },

    async insert() {
      await UsersService.create(this.data);
    },

    async update() {
      await UsersService.update(this.data.id, this.data);
    },

    async del(id) {
      if (!confirm("Delete user ?")) return;

      await UsersService.delete(id);
      this.getUsers();
    },

    async getUsers() {
      const res = await UsersService.getAll();
      this.users = res.data;
      this.isLoading = false;
    },

    async getRoles() {
      const res = await RolesService.getAll();
      this.roles = res.data;
    },
  },

  mounted() {
    this.modal = new Modal(this.$refs.modalRef);
  },

  async created() {
    this.isLoading = true;
    await Promise.all([this.getUsers(), this.getRoles()]);
  },
};
</script>